module.exports = __webpack_public_path__ + "img/menu-food-3.3bc18512.jpg";